import React from "react";

import {
  MpaArrowedListHorizontal,
  MpaArrowedListVertical
} from "../mpa-custom-ui-widgets/standard-list";
import {
  labelableSelectedStyle,
  labelableUnselectedStyle
} from "../../style-helper";

export class MpaSelector extends React.Component {
  constructor(props) {
    super(props);
    const { color, label, context, value, values } = props.meta.stack;
    this.state = {
      color,
      label,
      context,
      style: labelableUnselectedStyle(color),
      value,
      values
    };
  }

  componentWillUnmount() {
    const { socket } = this.props;
    socket.off("rx");
  }

  componentDidMount() {
    const { socket, meta } = this.props;
    socket.on(`rx`, data => {
      if (data.name === meta.stack.name || data.stack === meta.stack.name) {
        switch (data.type) {
          case "TOUCH":
            let style;
            if (data.val) {
              style = labelableSelectedStyle(this.state.color);
            } else {
              style = labelableUnselectedStyle(this.state.color);
            }
            this.setState({ style });
            break;
          case "VALUE":
            if (
              data.val !== undefined &&
              (typeof data.val === "string" || typeof data.val === "number")
            ) {
              this.setState({ value: data.val });
            }
            break;
          case "COLOR":
            this.setState({ color: data.val }, () =>
              this.setState({
                style: labelableUnselectedStyle(this.state.color)
              })
            );
            break;
          case "CONTEXT":
            if (data.val !== undefined && typeof data.val === "string") {
              this.setState({ context: data.val });
            }
            break;
          case "LABEL":
            if (data.val !== undefined && typeof data.val === "string") {
              this.setState({ label: data.val });
            }
            break;
          case "TYPECHANGE":
            if (
              data.val.type === "STRING_ARRAY" ||
              data.val.type === "NUMBER_ARRAY"
            ) {
              this.setState({ values: data.val.values });
            }
            break;
          default:
            break;
        }
      }
    });
  }

  render() {
    const { meta, orientation } = this.props;
    return (
      <div className="labelable" style={this.state.style}>
        <div className="label widget-label">
          <label>{this.state.label}</label>
        </div>
        <div className="label context-label">
          <label>{this.state.context}</label>
        </div>
        <div className="other-widget">
          {orientation === "VERTICAL" ? (
            <MpaArrowedListVertical
              defaultValue={this.state.value}
              key={meta.widget.name}
              value={this.state.value}
              values={this.state.values}
              assignedcolor={this.state.color}
            ></MpaArrowedListVertical>
          ) : (
            <MpaArrowedListHorizontal
              defaultValue={this.state.value}
              key={meta.widget.name}
              value={this.state.value}
              values={this.state.values}
              assignedcolor={this.state.color}
            ></MpaArrowedListHorizontal>
          )}
        </div>
      </div>
    );
  }
}
